import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";

export default function TermsOfUse() {
  return (
    <>
      <Head>
        <title>Terms of Use - Submitapp</title>
      </Head>
      <main className="container mx-auto mb-20 px-4">
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <b style={{ fontWeight: "normal" }}>
            <br />
          </b>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "16.25518798828125pt",
            marginBottom: "0pt",
          }}
          className="text-xl font-semibold"
        >
          TERMS OF USE&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginRight: "1.5440673828125pt",
            textAlign: "right",
            marginTop: "22.25555419921875pt",
            marginBottom: "0pt",
          }}
        >
          Last revision: 1 August 2022&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "0.7480010986328125pt",
            marginTop: "16.25555419921875pt",
            marginBottom: "0pt",
          }}
        >
          INTRODUCTION&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "0.03299713134765625pt",
            marginRight: "1.18096923828125pt",
            textIndent: "0.09900665283203125pt",
            textAlign: "justify",
            marginTop: "23.35955810546875pt",
            marginBottom: "0pt",
          }}
        >
          Welcome to the submitapp.io website, including its functions,
          applications or associated websites ("Website"). The Website is owned
          and operated by SubmitApp Technology inc. ("SubmitApp" or "we").
          SubmitApp is specialised in the recruitment of international students
          who wish to study in Canada (“Students”) and has developed related web
          tools, including the Website.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404391288757324",
            marginLeft: "0.25299835205078125pt",
            marginRight: "1.44940185546875pt",
            textIndent: "-0.17600250244140625pt",
            textAlign: "justify",
            marginTop: "8.442657470703125pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 0.17600250244140625pt",
          }}
        >
          The Website aims to connect recruitment agencies (“Agency”) and
          educational institutions partners of SubmitApp (“Institution”) to
          facilitate the recruitment of Students and the management of their
          application to programs offered by Institutions. It further aims to
          offer customers, partners and all other visitors of the Website
          (“User”, or “you”) information about SubmitApp’s services.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.240440559387207",
            marginLeft: "0.197998046875pt",
            marginRight: "1.00482177734375pt",
            textIndent: "0.6490020751953125pt",
            textAlign: "justify",
            marginTop: "8.44256591796875pt",
            marginBottom: "0pt",
          }}
        >
          Please read carefully these terms and conditions, as well as any other
          notice, policy or other documents hereby incorporated by reference
          (“Terms”). They constitute a contract between SubmitApp and you. If
          you do not agree to all modalities of these Terms, please stop using
          and exit the Website. By accepting these Terms or by accessing or
          using the Website, you represent that you have read, understood and
          agree to be bound by these Terms, on your behalf or as an authorized
          representative on behalf of the entity you represent.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "0.36299896240234375pt",
            marginRight: "2.212890625pt",
            textIndent: "0.16500091552734375pt",
            marginTop: "8.44256591796875pt",
            marginBottom: "0pt",
          }}
        >
          Our Privacy Policy form an integral part of these Terms. Capitalised
          terms which are not otherwise defined herein have the meaning set
          forth in the Policy.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "0.25299835205078125pt",
            marginRight: "2.22998046875pt",
            textIndent: "-0.1100006103515625pt",
            textAlign: "justify",
            marginTop: "8.442596435546875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 0.1100006103515625pt",
          }}
        >
          These Terms shall prevail over any terms and conditions of services
          issued by the User, contained in any document whatsoever, including an
          order form, by reference to a website or otherwise, regardless of the
          method or time of transmission.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.8690032958984375pt",
            marginTop: "8.442626953125pt",
            marginBottom: "0pt",
          }}
        >
          1. GENERAL CONDITIONS OF ACCESS&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.240442705154419",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.532470703125pt",
            textIndent: "-17.527000427246094pt",
            textAlign: "justify",
            marginTop: "14.463470458984375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.527000427246094pt",
          }}
        >
          1.1 You are hereby granted the limited right to access and use the
          Website, subject to the terms hereof. You may use the Website and its
          content solely for your non-commercial, personal purposes and/or to
          learn about SubmitApp’s services.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404392719268797",
            marginLeft: "4.198997497558594pt",
            textIndent: "-16.933006286621094pt",
            textAlign: "justify",
            marginTop: "14.092941284179688pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 16.933006286621094pt",
          }}
        >
          1.2 When accessing or using the Website, you agree to comply with: (a)
          these Terms; (ii) any other policies that SubmitApp may establish from
          time to time in connection with the Website; and (iv) all applicable
          law, statute, ordinance, rule, code, treaty, regulation or order of
          any governmental agency or authority, as amended, revised, modified or
          replaced from time to time (“Laws”). This includes more particularly,
          without limitation, intellectual property and privacy Laws.
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <b style={{ fontWeight: "normal" }}>
            <br />
          </b>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.240438985824585",
            marginLeft: "3.8690032958984375pt",
            marginRight: "1.04132080078125pt",
            textIndent: "-17.493995666503906pt",
            textAlign: "justify",
            marginTop: "5.905517578125pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.493995666503906pt",
          }}
        >
          1.3 The Website is not intended for minors. By accessing, using or
          browsing the Website, you represent and warrant that you have reached
          the age of majority in your place of residence or, if not, that you
          have obtained the prior consent of your parents or legal guardian
          authorizing you to use the Website.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404382705688477",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.32342529296875pt",
            textIndent: "-16.801002502441406pt",
            textAlign: "justify",
            marginTop: "14.09295654296875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 16.801002502441406pt",
          }}
        >
          1.4 Whenever you use the Website as a Student, you declare to
          understand that SubmitApp is a third party to any relationship you may
          have with an Agency or an Institution. SubmitApp may not be held
          liable for any discussion, negotiation, promise or agreement with or
          by an Agency or an Institution and does not intervene at any time in
          this regard. The User hereby waives any claim against SubmitApp
          regarding the interpretation, execution or arbitration of any claim to
          an Agency or an Institution.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.2750015258789062pt",
            marginTop: "30.092926025390625pt",
            marginBottom: "0pt",
          }}
        >
          2. RULES OF USE OF THE WEBSITE&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.319000244140625pt",
            marginTop: "14.46356201171875pt",
            marginBottom: "0pt",
          }}
        >
          2.1 By using the Website, the User expressly agrees to the
          following:&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404371261596678",
            marginLeft: "23.729904174804688pt",
            marginRight: "1.39093017578125pt",
            textIndent: "-11.861099243164062pt",
            textAlign: "justify",
            marginTop: "14.463653564453125pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 11.861099243164062pt",
          }}
        >
          i. not to harm or damage the Website, in particular not to overload,
          disturb, commit acts of piracy, modify the source code or reverse
          engineer the Website or any other associated software;&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404344081878662",
            marginLeft: "21.28778839111328pt",
            marginRight: "1.63287353515625pt",
            textIndent: "-14.666213989257812pt",
            marginTop: "7.8883056640625pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 14.666213989257812pt",
          }}
        >
          ii. not to attempt to gain access to SubmitApp's servers in any way,
          including through the use of the administrator account;&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "18.845680236816406pt",
            marginRight: "2.48883056640625pt",
            textIndent: "-16.83332061767578pt",
            marginTop: "14.09295654296875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 16.83332061767578pt",
          }}
        >
          iii. not to upload to or transmit through the Website any files, data,
          software or links that contain or point to a virus, Trojan horse,
          worm, or other harmful component;&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404371261596678",
            marginLeft: "19.05022430419922pt",
            marginRight: "2.70556640625pt",
            textIndent: "-16.595779418945312pt",
            marginTop: "7.888275146484375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 16.595779418945312pt",
          }}
        >
          iv. not to use any automated or manual process, software or other
          means or procedures to, among other things, access, collect
          information, browse or scan the Website;&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.240442705154419",
            marginLeft: "20.909332275390625pt",
            marginRight: "1.8963623046875pt",
            textIndent: "-14.747665405273438pt",
            textAlign: "justify",
            marginTop: "7.888275146484375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 14.747665405273438pt",
          }}
        >
          v. avoid, circumvent, or disable any technological secure access,
          security system, procedure, protocol or technological protection
          mechanism that may be included or established in or as part of the
          Website or any software/hardware used by the Website;&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "2.4808796882629394",
            marginLeft: "15.208702087402344pt",
            marginRight: "73.89761352539062pt",
            textIndent: "2.442108154296875pt",
            marginTop: "7.8881683349609375pt",
            marginBottom: "0pt",
          }}
        >
          vi. use the Website only for the purposes expressly permitted by these
          Terms; vii. not to interfere with the use of the Website;&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.917040729522705",
            marginLeft: "12.766586303710938pt",
            marginRight: "6.41680908203125pt",
            textIndent: "-5.46722412109375pt",
            marginTop: "2.722137451171875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 5.46722412109375pt",
          }}
        >
          viii. not to improperly make complaints or false reports regarding the
          Website; ix. not to impersonate another person or otherwise use an
          identity other than your own; and x. induce or encourage any third
          party to do any of the above mentioned.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.417999267578125pt",
            marginTop: "23.890724182128906pt",
            marginBottom: "0pt",
          }}
        >
          3. PROTECTION OF PERSONAL INFORMATION
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <b style={{ fontWeight: "normal" }}>
            <br />
          </b>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "3.4619979858398438pt",
            marginRight: "1.2567138671875pt",
            textIndent: "-17.670005798339844pt",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.670005798339844pt",
          }}
        >
          3.1 The protection of your Personal Information as well as the respect
          of your privacy is one of our priorities. Information on the nature of
          the information collected during your use of the Website, the reasons
          for which this information is collected and the use made of it is
          available in our Privacy Policy which you are responsible for
          consulting and declare having read and understood by your acceptance
          of these Terms.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.24044828414917",
            marginLeft: "3.4619979858398438pt",
            marginRight: "1.346923828125pt",
            textIndent: "-17.934005737304688pt",
            textAlign: "justify",
            marginTop: "14.09283447265625pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.934005737304688pt",
          }}
        >
          3.2 You acknowledge that SubmitApp does not control, supervise or
          answer for how Agencies and Institutions handle the Personal
          Information of Students and that SubmitApp merely hosts such Personal
          Information to enable their use of its services.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.2089996337890625pt",
            marginTop: "14.0926513671875pt",
            marginBottom: "0pt",
          }}
        >
          4. INTELLECTUAL PROPERTY&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "22.02300262451172pt",
            marginTop: "14.46368408203125pt",
            marginBottom: "0pt",
          }}
        >
          Intellectual Property of the User&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "3.1429977416992188pt",
            marginRight: "1.46484375pt",
            textIndent: "-18.220001220703125pt",
            textAlign: "justify",
            marginTop: "14.46368408203125pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 18.220001220703125pt",
          }}
        >
          4.1 By submitting any content to the Website, including feedback,
          suggestions of improvements or other comments or ideas (“Feedback”),
          you grant SubmitApp an irrevocable, perpetual, non-exclusive,
          transferable, royalty-free license to display, broadcast, modify,
          reproduce or otherwise use such Feedback, at SubmitApp's discretion in
          the course of the operations of its business, as well as the
          improvement of its services and the Website.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "22.02300262451172pt",
            marginTop: "14.092803955078125pt",
            marginBottom: "0pt",
          }}
        >
          Intellectual property of SubmitApp&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404414176940917",
            marginLeft: "3.1429977416992188pt",
            marginRight: "1.06207275390625pt",
            textIndent: "-17.889999389648438pt",
            textAlign: "justify",
            marginTop: "14.46356201171875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.889999389648438pt",
          }}
        >
          4.2 You are hereby informed and acknowledge that SubmitApp is the
          exclusive owner of all intellectual property rights related to : (a)
          the Website, including all text, photos, maps, images, data, graphics,
          trade-marks, logos and slogans created or used by SubmitApp, whether
          registered or unregistered; (b) any tools, hardware and software,
          source code used to enable the functionality of the Website; and (c)
          the graphic design, user interface and the look and feel of the
          Website. Some text, photos, maps, images, data, graphics, trade-marks,
          logos and slogans may be owned by third parties, who retain all their
          intellectual property rights.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "3.1429977416992188pt",
            marginRight: "0.99285888671875pt",
            textIndent: "-17.95600128173828pt",
            textAlign: "justify",
            marginTop: "14.092803955078125pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.95600128173828pt",
          }}
        >
          4.3 You may download or print certain information, material or content
          appearing on the Website for informational and personal purposes only,
          provided that you ensure that SubmitApp’s intellectual property rights
          are maintained at all times.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.24044828414917",
            marginLeft: "3.1429977416992188pt",
            marginRight: "2.0279541015625pt",
            textIndent: "-18.05500030517578pt",
            textAlign: "justify",
            marginTop: "14.09283447265625pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 18.05500030517578pt",
          }}
        >
          4.4 The User undertakes, for the entire duration of the underlying
          rights, never to infringe, directly or indirectly, on any of
          SubmitApp's rights in its intellectual property, in particular not to
          :&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404371261596678",
            marginLeft: "23.729904174804688pt",
            marginRight: "1.375244140625pt",
            textIndent: "-19.4490966796875pt",
            marginTop: "14.092697143554688pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 19.4490966796875pt",
          }}
        >
          i. adopt or use any trade-marks or other intellectual property that is
          likely to cause confusion with, or is an imitation of, the
          intellectual property of SubmitApp.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404261112213135",
            marginLeft: "21.28778839111328pt",
            marginRight: "1.07049560546875pt",
            textIndent: "-22.166213989257812pt",
            marginTop: "14.093048095703125pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 22.166213989257812pt",
          }}
        >
          ii. not to seek, directly or indirectly,to invalidate, attack or
          otherwise challenge the legitimacy of SubmitApp's rights in its
          intellectual property
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <b style={{ fontWeight: "normal" }}>
            <br />
          </b>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.24044828414917",
            marginLeft: "18.845680236816406pt",
            marginRight: "1.56182861328125pt",
            textIndent: "-24.03632354736328pt",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 24.03632354736328pt",
          }}
        >
          iii. not to use, reproduce, copy, reverse engineer SubmitApp's
          intellectual property and Website other than in accordance with these
          Terms without its prior written consent even after the end this
          agreement.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.4619979858398438pt",
            marginTop: "41.393310546875pt",
            marginBottom: "0pt",
          }}
        >
          5. THIRD-PARTY WEBSITES&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404359817504882",
            marginLeft: "3.4619979858398438pt",
            marginRight: "1.09991455078125pt",
            textIndent: "-17.538002014160156pt",
            textAlign: "justify",
            marginTop: "14.46380615234375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.538002014160156pt",
          }}
        >
          5.1 The Website may allow you to link or connect to use features
          offered by applications, services or sites operated by third parties
          that are not owned or controlled by SubmitApp (collectively, the
          "Third-Party Applications"). We provide these links only as a
          convenience to you and you access them at your own risk, as SubmitApp
          has no control over them. You may also be subject to additional terms
          and conditions of use that may apply when you use or purchase, as
          applicable, certain products or services related to the Third-Party
          Applications. SubmitApp has not reviewed these policies and cannot
          provide any recommendations or advice with respect to their content or
          in any way be linked to them.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.417999267578125pt",
            marginTop: "14.09307861328125pt",
            marginBottom: "0pt",
          }}
        >
          6. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404344081878662",
            marginLeft: "3.417999267578125pt",
            marginRight: "1.20037841796875pt",
            textIndent: "-17.779998779296875pt",
            textAlign: "justify",
            marginTop: "14.4637451171875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.779998779296875pt",
          }}
        >
          6.1 We undertake to take reasonable technical measures to protect the
          physical security and integrity of the Website's functionalities.
          However, given the very nature of the public network that is the
          internet, the User acknowledges and accepts that the security of
          transmissions via the internet cannot be guaranteed.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404366970062255",
            marginLeft: "3.417999267578125pt",
            marginRight: "1.11639404296875pt",
            textIndent: "-17.978004455566406pt",
            textAlign: "justify",
            marginTop: "14.0931396484375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.978004455566406pt",
          }}
        >
          6.2 Your use of the Website may be interrupted or discontinued, in
          whole or in part, at any time. It cannot be excluded that the Website
          may contain errors, omissions, inaccuracies or may not be complete or
          up-to-date. When an error is noticed, we will attempt to correct it as
          soon as possible and make reasonable efforts to notify affected Users.
          The Website may also be unavailable from time to time for maintenance,
          updates, hardware/software failure, repairs, power outages, hacking,
          denial of service attacks, large unplanned service requests or for any
          other reason.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404394149780273",
            marginLeft: "3.417999267578125pt",
            marginRight: "0.1326904296875pt",
            textIndent: "-17.582000732421875pt",
            textAlign: "justify",
            marginTop: "14.0931396484375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.582000732421875pt",
          }}
        >
          6.3 SUBMITAPP PROVIDES THE WEBSITE ON AN "AS IS" AND "AS AVAILABLE"
          BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
          INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE OR NON-INFRINGEMENT. THE USER USES THE WEBSITE AT
          ITS OWN RISK. SUBMITAPP DOES NOT GUARANTEE THAT THE WEBSITE IS ALWAYS
          SAFE AND SECURE. THERE IS ALSO NO GUARANTEE THAT THE WEBSITE IS FREE
          OF ERRORS OR THAT IT WILL ALWAYS OPERATE WITHOUT INTERRUPTION, DELAY
          OR IMPERFECTION. SUBMITAPP ASSUMES NO RESPONSIBILITY FOR THE ACTIONS,
          CONTENT, INFORMATION OR DATA OF THIRD PARTIES. THE USER RELEASES
          SUBMITAPP, ITS DIRECTORS, OFFICERS, EMPLOYEES AND AGENTS FROM ANY
          LIABILITY RELATED TO THE USE OF THE WEBSITE, EXCEPT IN CASE OF GROSS
          NEGLIGENCE OR INTENTIONAL FAULT BY SUBMITAPP, EVEN IF SUBMITAPP HAS
          BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGES. SUBMITAPP CANNOT
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <b style={{ fontWeight: "normal" }}>
            <br />
          </b>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404398441314697",
            marginLeft: "21pt",
            marginRight: "0.25103759765625pt",
            textIndent: "0.8030014038085938pt",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          BE HELD RESPONSIBLE FOR LOSS OF PROFITS, LOSS OF DATA OR ANY OTHER
          CONSEQUENTIAL, SPECIAL, INDIRECT OR INCIDENTAL DAMAGES. YOU ARE SOLELY
          LIABLE FOR MAKING THE APPROPRIATE BACK-UP TO RECOVER YOUR DATA IF
          NECESSARY. SUBMITAPP'S LIABILITY WILL IN ALL CASES BE LIMITED TO 100
          CANADIAN DOLLARS. IN THE EVENT THAT APPLICABLE LAW DOES NOT ALLOW SUCH
          LIMITATION OR EXCLUSION OF LIABILITY OR INCIDENTAL OR CONSEQUENTIAL
          DAMAGES, THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY. IN SUCH
          EVENT, SUBMITAPP'S LIABILITY SHALL BE LIMITED TO THE MINIMUM EXTENT
          PERMITTED BY APPLICABLE LAW.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.516998291015625pt",
            marginTop: "14.09283447265625pt",
            marginBottom: "0pt",
          }}
        >
          7. INDEMNITY&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.240440845489502",
            marginLeft: "3.516998291015625pt",
            marginRight: "1.263916015625pt",
            textIndent: "-17.84600067138672pt",
            textAlign: "justify",
            marginTop: "14.46380615234375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.84600067138672pt",
          }}
        >
          7.1 By your use of the Website, you agree to indemnify, defend and
          hold SubmitApp and its directors, officers, employees and agents
          harmless from and against any and all liabilities, costs and expenses,
          including reasonable attorneys' fees and court costs incurred by
          SubmitApp in connection with any claim, demand or proceeding, either
          by you or any third party, arising out of or relating to : (1) your
          violation of these Terms by you or your representative; (2) your use
          of the Website; (3) the collection, processing, usage, storage and/or
          transfer of your Personal Information by an Agency or an Institution;
          (4) any claim, dispute or other disagreement with a an Agency or an
          Institution; (5) the inaccuracy of any of your representations; and
          (4) any misconduct by you or any person for whom you are responsible
          under these terms or by Law.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404288291931151",
            marginLeft: "3.516998291015625pt",
            marginRight: "0.5755615234375pt",
            textIndent: "-18.197998046875pt",
            textAlign: "justify",
            marginTop: "14.092803955078125pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 18.197998046875pt",
          }}
        >
          7.2 You acknowledge and agree that any costs incurred by SubmitApp in
          defending any claim by yourself or a third party for which an
          indemnity obligation is provided for hereunder will become immediately
          reimbursable by you upon written request by SubmitApp.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.4509963989257812pt",
            marginTop: "14.0931396484375pt",
            marginBottom: "0pt",
          }}
        >
          8. RECOURSE AND REMEDIES&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404344081878662",
            marginLeft: "3.4509963989257812pt",
            marginRight: "1.0980224609375pt",
            textIndent: "-17.582000732421875pt",
            textAlign: "justify",
            marginTop: "14.4637451171875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.582000732421875pt",
          }}
        >
          8.1 In the event that SubmitApp considers, in its sole discretion,
          that a User does not comply with these Terms, any other SubmitApp
          policy or any applicable Law, SubmitApp reserves the right to restrict
          or suspend the User's use of the Website, without notice or
          compensation and without prejudice to any other rights and remedies
          that SubmitApp may have.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.240442705154419",
            marginLeft: "3.4509963989257812pt",
            marginRight: "1.58966064453125pt",
            textIndent: "-17.94500732421875pt",
            marginTop: "14.0931396484375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.94500732421875pt",
          }}
        >
          8.2 SubmitApp shall also have the discretion to do anything useful or
          necessary to comply with any Law or to enforce these Terms.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.4619979858398438pt",
            marginTop: "30.092575073242188pt",
            marginBottom: "0pt",
          }}
        >
          9. APPLICABLE LAW AND DISPUTE RESOLUTION&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404371261596678",
            marginLeft: "3.4619979858398438pt",
            marginRight: "1.7408447265625pt",
            textIndent: "-18.263999938964844pt",
            marginTop: "14.463775634765625pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 18.263999938964844pt",
          }}
        >
          9.1 These Terms, their interpretation, execution, application and
          validity are subject to the Laws in force in the province of Quebec,
          excluding its conflict of law rules.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404648780822753",
            marginLeft: "3.4619979858398438pt",
            marginRight: "1.63861083984375pt",
            textIndent: "-17.791000366210938pt",
            marginTop: "14.092864990234375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.791000366210938pt",
          }}
        >
          9.2 In the event of any disagreement between you and SubmitApp on the
          application of these Terms, with the exception of a dispute with an
          Agency or an Institution, in which case any
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <b style={{ fontWeight: "normal" }}>
            <br />
          </b>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.24044828414917",
            marginLeft: "21.032997131347656pt",
            marginRight: "1.58673095703125pt",
            textIndent: "0.6819992065429688pt",
            textAlign: "justify",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          recourse must be addressed exclusively to the aforementioned, we
          invite you first to communicate with us in the manner provided for in
          these Terms. We will try to the extent possible to reach an amicable
          settlement and find an appropriate solution to the situation, without
          prejudice to the right of each party to apply to the courts in the
          manner and at the time it deems appropriate.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.24044828414917",
            marginLeft: "3.4619979858398438pt",
            marginRight: "1.4830322265625pt",
            textIndent: "-17.934005737304688pt",
            textAlign: "justify",
            marginTop: "14.092529296875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.934005737304688pt",
          }}
        >
          9.3 Should a dispute nevertheless arise, you agree that it shall be
          resolved by the competent court of the judicial district of Montréal,
          the exclusive jurisdiction of which you hereby acknowledge.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "4.198997497558594pt",
            marginTop: "24.093017578125pt",
            marginBottom: "0pt",
          }}
        >
          10. NOTICES&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404414176940917",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.22381591796875pt",
            textIndent: "-16.833999633789062pt",
            textAlign: "justify",
            marginTop: "14.46331787109375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 16.833999633789062pt",
          }}
        >
          10.1 All notices to be provided by SubmitApp to you under these Terms
          may be delivered in writing (a) by registered mail, courier service or
          email to the address provided by you when contacting or otherwise
          communicating with us. You must give notice to SubmitApp in writing by
          a nationally recognized overnight delivery service to SubmitApp’s
          postal or email address set forth in the section “Contact us” below;
          All notices by electronic mail shall be deemed to have been received
          immediately upon delivery if sent prior to 5 p.m. (local time of the
          recipient) or otherwise on the next business day. Notices per
          registered mail or courier service shall be deemed received on the day
          of the actual delivery.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.8690032958984375pt",
            marginTop: "14.092620849609375pt",
            marginBottom: "0pt",
          }}
        >
          11. GENERAL PROVISIONS&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404288291931151",
            marginLeft: "4.198997497558594pt",
            marginRight: "2.4609375pt",
            textIndent: "-17.197006225585938pt",
            textAlign: "justify",
            marginTop: "14.4637451171875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.197006225585938pt",
          }}
        >
          11.1 Any declaration by a court that any provision hereof is void or
          unenforceable shall not affect the validity or enforceability of the
          remaining provisions of these Terms, which shall remain in full force
          and effect.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.24044828414917",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.46038818359375pt",
            textIndent: "-17.054000854492188pt",
            textAlign: "justify",
            marginTop: "14.0931396484375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.054000854492188pt",
          }}
        >
          11.2 The failure or delay by a party to exercise any right, remedy or
          privilege under these Terms will not constitute a waiver of such
          right, remedy or privilege. Similarly, such party shall not be
          precluded from exercising any right, remedy or privilege at a later
          date which it has not previously exercised, in whole or in part.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.24044828414917",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.52093505859375pt",
            textIndent: "-17.142005920410156pt",
            textAlign: "justify",
            marginTop: "14.092529296875pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.142005920410156pt",
          }}
        >
          11.3 These Terms is binding upon and enforceable not only against the
          parties, but also against their respective executors, estates,
          successors, heirs, legatees, assigns, agents or servants and their
          respective permitted assignees.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.240431547164917",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.68341064453125pt",
            textIndent: "-16.999000549316406pt",
            textAlign: "justify",
            marginTop: "14.093002319335938pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 16.999000549316406pt",
          }}
        >
          11.4 SubmitApp may assign, at any time, its rights and obligations
          under these Terms to a third party without having to obtain the
          consent of the User at the time of the assignment. The User may not
          assign, alienate or otherwise transfer its rights and obligations
          under these Terms to anyone else without the express consent of
          SubmitApp.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404371261596678",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.09136962890625pt",
            textIndent: "-17.152999877929688pt",
            textAlign: "justify",
            marginTop: "14.093154907226562pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.152999877929688pt",
          }}
        >
          11.5 The User acknowledges that these Terms has the same effect and
          value as if it had been signed personally by him/her. A printed
          version of these Terms or of any notice sent by e-mail will be
          admissible in litigation, as will any other business document or
          record generally kept in paper form.
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        >
          <b style={{ fontWeight: "normal" }}>
            <br />
          </b>
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.8690032958984375pt",
            marginTop: "5.90509033203125pt",
            marginBottom: "0pt",
          }}
        >
          12. MODIFICATIONS&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404419898986816",
            marginLeft: "4.198997497558594pt",
            marginRight: "0.96466064453125pt",
            textIndent: "-16.900001525878906pt",
            textAlign: "justify",
            marginTop: "14.46331787109375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 16.900001525878906pt",
          }}
        >
          12.1 SubmitApp may, in its sole discretion, modify, add, delete,
          restrict or suspend, in whole or in part, any functionality of the
          Website, without any notice or liability to you or any other person.
          These Terms are also subject to change at any time by SubmitApp, in
          which case the newest version will automatically replace the previous
          one. If we make changes, we will take steps to notify you, either
          directly or by posting a notice on the Website. By continuing to
          browse the Website, you agree to be bound by these Terms, including
          any changes made to them. If you refuse to accept the updated version
          of these Terms upon a specific request from SubmitApp, certain
          features of the Website may become inaccessible.&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "3.8690032958984375pt",
            marginTop: "14.09307861328125pt",
            marginBottom: "0pt",
          }}
        >
          13. CONTACT US&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404066562652587",
            marginLeft: "4.198997497558594pt",
            marginRight: "1.9554443359375pt",
            textIndent: "-17.16400146484375pt",
            marginTop: "14.46380615234375pt",
            marginBottom: "0pt",
            padding: "0pt 0pt 0pt 17.16400146484375pt",
          }}
        >
          13.1 All requests for technical support or questions regarding the
          Website, these Terms or other services offered by SubmitApp may be
          directed to :&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "21.847000122070312pt",
            marginTop: "8.44293212890625pt",
            marginBottom: "0pt",
          }}
        >
          Phone number: +1-514-846-6477&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "21.869003295898438pt",
            marginTop: "7.81195068359375pt",
            marginBottom: "0pt",
          }}
        >
          Email : legal@submitapp.io&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            marginLeft: "21.869003295898438pt",
            marginTop: "7.81195068359375pt",
            marginBottom: "0pt",
          }}
        >
          Address: SubmitApp Technology inc. 3201-1155 Rue de la Montagne,
          Montreal, QC, H3G 0C7&nbsp;
        </p>
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2",
            textAlign: "center",
            marginTop: "0pt",
            marginBottom: "0pt",
          }}
        />
        <p
          dir="ltr"
          style={{
            lineHeight: "1.2404510021209716",
            marginRight: "1.030517578125pt",
            textIndent: "0.8030014038085938pt",
            marginTop: "29.924896240234375pt",
            marginBottom: "0pt",
          }}
        >
          BY CLICKING ON THE "I ACCEPT" BUTTON, THE USER CONFIRMS THAT IT AND
          AGREES AND UNDERTAKES TO COMPLY WITH ALL THE PROVISIONS OF THESE
          TERMS.
        </p>
        <br />
      </main>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
